import { useContext } from "react";
import { AppContext, AppContextProps } from "./context";
import { useAppContextController } from "./controller";

const AppContextProvider: React.FC<{ children: any }> = ({ children }) => {
  return (
    <AppContext.Provider value={{ ...useAppContextController() }}>
      {children}
    </AppContext.Provider>
  );
};

function useApp(): AppContextProps {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error("useApp must be used within an AppContextProvider.");
  }

  return context;
}

export { AppContextProvider, useApp };
